<template>
  <div class="border-b border-b-light-gray pb-5 sm:pb-[29.5px]">
    <h5 class="text-[19px]/[22px] sm:text-[27px]/[31px] font-semibold mt-[17px] mb-[13px]">
      Delivery information
    </h5>
    <div class="flex flex-col gap-[17px]">
      <div
        v-for="(field, index) in deliveryInfo"
        :key="index"
        class="w-full flex flex-col justify-center relative"
      >
        <!-- Use AddressAutocompleteField for the main address field -->
        <AddressAutocompleteField
          v-if="isAddressField(field.field)"
          :name="field.field"
          :rules="required"
          :placeholder="field.placeholder"
          :city-field-name="getCityFieldName()"
          :state-field-name="getStateFieldName()"
          :zip-field-name="getZipFieldName()"
        />
        <!-- Use regular CustomField for other fields -->
        <CustomField
          v-else-if="!field.handler"
          :name="field.field"
          :rules="
            field.field.includes('2')
            || field.field.includes('two')
            ? []
            : required
          "
          :placeholder="field.placeholder"
        />
        <!-- Use ZipField for zip code field -->
        <ZipField
            v-else-if="field.handler"
            :name="field.field"
            :rules="required"
            :placeholder="field.placeholder"
            :model-value="defaultPostcode"
        />
        <span class="text-red-500 text-xs pt-1">{{ errors && errors[field.field] }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import CustomField from '@components/reusable/CustomField.vue'
import AddressAutocompleteField from '@components/reusable/AddressAutocompleteField.vue'
import ZipField from "@components/reusable/ZipField.vue";
import { required } from '@utills/helpers/validation'

export default defineComponent({
  components: { ZipField, CustomField, AddressAutocompleteField },
  props: {
    deliveryInfo: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    defaultPostcode: {
      type: null,String,Number,
      default: null
    }
  },
  setup(props) {
    // Helper function to check if field is the main address field
    const isAddressField = (fieldName: string) => {
      return fieldName.includes('delivery_line_one') || fieldName.includes('address_line_1')
    }

    // Helper functions to get related field names
    const getCityFieldName = () => {
      // Check if we're in checkout (delivery_city) or signup (city-{index})
      const addressField = props.deliveryInfo.find((field: any) =>
        field.field.includes('delivery_line_one') || field.field.includes('address_line_1')
      )

      let cityFieldName = ''
      if (addressField?.field.includes('delivery_line_one')) {
        cityFieldName = 'delivery_city'
      } else {
        // Extract index from address_line_1-{index}
        const match = addressField?.field.match(/-(\d+)$/)
        cityFieldName = match ? `city-${match[1]}` : 'city-0'
      }
      console.log('getCityFieldName:', cityFieldName, 'from address field:', addressField?.field)
      return cityFieldName
    }

    const getStateFieldName = () => {
      const addressField = props.deliveryInfo.find((field: any) =>
        field.field.includes('delivery_line_one') || field.field.includes('address_line_1')
      )

      let stateFieldName = ''
      if (addressField?.field.includes('delivery_line_one')) {
        stateFieldName = 'delivery_state'
      } else {
        const match = addressField?.field.match(/-(\d+)$/)
        stateFieldName = match ? `state-${match[1]}` : 'state-0'
      }
      console.log('getStateFieldName:', stateFieldName, 'from address field:', addressField?.field)
      return stateFieldName
    }

    const getZipFieldName = () => {
      const addressField = props.deliveryInfo.find((field: any) =>
        field.field.includes('delivery_line_one') || field.field.includes('address_line_1')
      )

      let zipFieldName = ''
      if (addressField?.field.includes('delivery_line_one')) {
        zipFieldName = 'delivery_zip'
      } else {
        const match = addressField?.field.match(/-(\d+)$/)
        zipFieldName = match ? `zip-${match[1]}` : 'zip-0'
      }
      console.log('getZipFieldName:', zipFieldName, 'from address field:', addressField?.field)
      return zipFieldName
    }

    return {
      required,
      isAddressField,
      getCityFieldName,
      getStateFieldName,
      getZipFieldName
    }
  }
})
</script>
